var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"order-detail-status-badge",class:`-is-${_vm.variant}`},[(_vm.icon)?_c('v-icon',{staticClass:"order-detail-status-badge__icon",attrs:{"size":"16"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{staticClass:"order-detail-status-badge__label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }